import React from 'react'
import { AdCreative, AssetApprovalStatus } from '@marketing-milk/interfaces'

/**
 * Whether this ad carries a client approval worth marking.
 *
 * Only an approval, and only where one exists. Most packets are never reviewed at
 * all, so anything rendered for "no verdict yet" fires on nearly every card and
 * reads as a problem the AE has to solve. Rejection is marked by the picker's
 * withheld ribbon instead — a second red mark beside it says nothing the ribbon
 * didn't.
 */
export const hasClientApproval = (creative: AdCreative) =>
  creative.reviewStatus === AssetApprovalStatus.Approved

/**
 * A badge rather than a border: the card already spends its border on selection
 * and on highlight, and selection wins, so a green border would disappear the
 * moment the AE picked the ad.
 */
export const CreativeVerdictBadge = () => (
  <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold text-green-800">
    <i className="fa fa-check" aria-hidden="true" />
    Client approved
  </span>
)
